<template>
  <v-card>
    <div class="pa-4">
      <div>
        <h2>{{ $route.params.news.title }}</h2>
        <div class="d-flex">
          <span>Author:<a href="">John</a></span>
          <time class="ml-auto">{{
            moment($route.params.news.datetime.toDate()).format(
              "DD-MM-YYYY hh:mm:ss A"
            )
          }}</time>
        </div>
      </div>
      <v-divider class="my-3"></v-divider>
      <div class="news-content">
        <p>
          {{ $route.params.news.description }}
        </p>
      </div>
    </div>
  </v-card>
</template>

<script>
import moment from "moment";
export default {
  methods: {
    moment,
  },
  updated() {
    window.scrollTo(0, 0);
  },
};
</script>

<style>
</style>